var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35238",
    "data-name": "Group 35238",
    transform: "translate(-757.7 -295)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9815",
    "data-name": "Rectangle 9815",
    width: 40,
    height: 40,
    transform: "translate(757.7 295)",
    fill: "red",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35292",
    "data-name": "Group 35292",
    transform: "translate(764.95 298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72309",
    "data-name": "Path 72309",
    d: "M44.727,55.882,43.25,67l7.8-4.68a1.9,1.9,0,0,1,.517-.259.85.85,0,0,1,.364,0,1.9,1.9,0,0,1,.517.259L60.25,67,58.774,55.877m.5-19.054a2.592,2.592,0,0,0,1.4,1.4l2.225.922a2.592,2.592,0,0,1,1.4,3.386l-.921,2.224a2.587,2.587,0,0,0,0,1.984l.919,2.223a2.592,2.592,0,0,1-1.4,3.387l-2.223.921a2.592,2.592,0,0,0-1.4,1.4L58.351,56.9a2.592,2.592,0,0,1-3.386,1.4l-2.223-.921a2.592,2.592,0,0,0-1.983,0l-2.225.92a2.591,2.591,0,0,1-3.384-1.4l-.922-2.226a2.591,2.591,0,0,0-1.4-1.4L40.6,52.351a2.592,2.592,0,0,1-1.4-3.385l.921-2.224a2.592,2.592,0,0,0,0-1.983l-.92-2.227a2.592,2.592,0,0,1,1.4-3.387l2.224-.921a2.591,2.591,0,0,0,1.4-1.4l.922-2.225a2.592,2.592,0,0,1,3.386-1.4l2.224.921a2.591,2.591,0,0,0,1.983,0l2.226-.918a2.592,2.592,0,0,1,3.386,1.4l.922,2.226Z",
    transform: "translate(-39 -33)",
    fill: "none",
    stroke: "#f49c43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertified);
export default __webpack_public_path__ + "static/media/certified.f639214c104f4d54a3fa49134d12e22d.svg";
export { ForwardRef as ReactComponent };